// extracted by mini-css-extract-plugin
module.exports = {"filters":"AuthorsMosaicFilters_filters__ANbLX","search":"AuthorsMosaicFilters_search__mkWXc","stats":"AuthorsMosaicFilters_stats__UbCP2"};